export default __webpack_public_path__ + "static/media/session-expired-illustration.03fdb57e.jpg";